import { ModelMixin } from '../core/base-generic.model';
import { ApplicantInterviewers } from './applicant-interviewers.model';
import { Applicant } from './applicant.model';
import { Interview } from './interview.model';

export class ApplicantInterviews extends ModelMixin<ApplicantInterviews>() {
    protected static _resource = 'applicantTracker/applicantInterviews';
    protected static _version = 'v2';
    protected static _serializeAttributes = ['feedbackDueDate'];
    protected static _datetimes = ['createdAt', 'updatedAt', 'deletedAt'];

    get atsApplicantId(): number {
        return this._attributes['atsApplicantId'];
    }

    get atsInterviewId(): number {
        return this._attributes['atsInterviewId'];
    }

    get feedbackDueDate(): Date {
        return this._attributes['feedbackDueDate'];
    }

    set feedbackDueDate(val: Date) {
        this._attributes['feedbackDueDate'] = val;
    }

    get interview(): Interview {
        return this.hasOne(Interview, 'interview');
    }

    get applicant(): Applicant {
        return this.hasOne(Applicant, 'applicant');
    }

    get applicantInterviewer(): ApplicantInterviewers {
        return this.hasOne(ApplicantInterviewers, 'applicantInterviewer');
    }

    get applicantInterviewers(): ApplicantInterviewers[] {
        return this.hasMany(ApplicantInterviewers, 'applicantInterviewers');
    }
}
